import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  inject,
  OnInit,
} from '@angular/core';
import {
  BaseComponent,
  COMPANY_SIZE,
  CompanyDetails,
  CountryStateCityService,
  NationalDigitsSpacedPipe,
} from '@app-utils';
import { AuthFlowService } from '../../services';
import { takeUntil } from 'rxjs';
import { TitleCasePipe } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'auth-details-card',
  standalone: true,
  imports: [TitleCasePipe, TranslateModule, NationalDigitsSpacedPipe],
  templateUrl: './details-card.component.html',
  styleUrl: './details-card.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DetailsCardComponent extends BaseComponent implements OnInit {
  private readonly _csc = inject(CountryStateCityService);
  private readonly _authFlowSvc = inject(AuthFlowService);
  private readonly _cdr = inject(ChangeDetectorRef);

  company: CompanyDetails | null = null;

  size = '';

  country = '';

  ngOnInit(): void {
    this._authFlowSvc.companyDetail$
      .pipe(takeUntil(this._destroy$))
      .subscribe((res) => {
        this.company = res;
        if (this.company?.numOfEmp) {
          this.size =
            COMPANY_SIZE.find((item) => item.val === this.company?.numOfEmp)
              ?.title || '';
        }
        if (this.company?.country) {
          this.country =
            this._csc
              .getCountries()
              .find((item) => item.code3 === this.company?.country)?.name || '';
        }
        this._cdr.detectChanges();
      });
  }

  get nameInitials(): string {
    if (!this.company?.orgName) return 'CN';
    const spl = this.company.orgName.split(' ');
    const first = spl[0].charAt(0);
    const sec = spl.length > 1 ? spl[1].charAt(0) : spl[0].charAt(1) || '';
    return `${first}${sec}`.toUpperCase();
  }
}
